import { createStore } from 'vuex'

export default createStore({
  state: {
    version: 'v0.9.2',
    dev: {
      deleteSaveAfterSuccess: true
    },
    DEMO: true, //убрать когда все урлы будут настроены
    returnlink: '', //Ссылка "вернуться на сайт"
    sendUrl: 'https://rosbankinsurance.ru/bitapi/prolonging/request/add/', //Урл куда отправлять форму
    prolongPaymentUrl: './', //Урл куда отправлять форму
    prolongPaymentRedirect: './', //Урл для оплаты
    SMSrequestUrl: 'https://rosbankinsurance.ru/bitapi/personal/sms/send/', //Урл куда отправлять запрос на отправку СМС по номеру
    checkCodeUrl: 'https://rosbankinsurance.ru/bitapi/personal/sms/check/', //Урл куда отправлять запрос на проверку СМС-кода
    show: true,
    thanksShow: false,
    errorPopup: {},
    errorPopupShow: false,
    codeOk: false,
    step: 1,
    DaDataToken: 'd19d3963dafe68db009a421b3baaf979385ab67b',
    DaDataUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    DaDataFIOUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio',
    DaDataCountryUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/country',
    DaDataCodeUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fms_unit',
    loads: [],
    codeTimer: null,
    codeSeconds: 0,
    loaderSettings: {
      appearDelay: 3000,
      title: 'Уважаемый клиент!',
      content: 'Время передачи данных может быть&nbsp;длительным.<br> Зависит от&nbsp;количества и&nbsp;объема отправленных&nbsp;вами&nbsp;файлов.<br> Пожалуйста, не&nbsp;скрывайте и&nbsp;не&nbsp;перезагружайте&nbsp;страницу. <br> Дождитесь&nbsp;загрузки.'
    },
    form: {
      step1: {
        id: '',
        name: '',
        bank: '',
        customBankName: '',
        tel: '',
        email: '',
        prolongPayment: ''
      },
      additions: {
        btn: ''
      }
    }
  },
  mutations: {
    setProlongPaymentRedirect(state, val) {
      state.prolongPaymentRedirect = val
    },
    setForm(state, form) {
      state.form = form
    },
    addLoad(state, val) {
      state.loads = [...state.loads, val]
    },
    removeLoad(state, val) {
      state.loads = state.loads.filter(el => el != val)
    },
    setShow(state, val) {
      state.show = val
    },
    setThanksShow(state, val) {
      state.thanksShow = val
    },
    nextStep(state) {
      state.step++
    },
    prevStep(state) {
      state.step--
    },
    setStep(state, val) {
      state.step = val
    },
    setCodeTimer(state, val) {
      state.codeTimer = val
    },
    setCodeSeconds(state, val) {
      state.codeSeconds = val
    },
    setErrorPopup(state, val) {
      state.errorPopup = val
    },
    setErrorPopupShow(state, val) {
      state.errorPopupShow = val
    },
    setCodeOk(state, value) {
      state.codeOk = value
    }
  },
  actions: {
    showErrorPopup({ commit }, popup) {
      if (!popup.title)
        return console.error('Неверный попап ошибки:', popup)

      if (!popup.action)
        popup.action = () => false
      if (popup.closable === undefined)
        popup.closable = true

      const mainAction = popup.action
      popup.action = async () => {
        commit('setErrorPopupShow', false)
        await new Promise(r => setTimeout(r, 210))
        mainAction()
      }
      commit('setErrorPopup', popup)
      commit('setErrorPopupShow', true)
      console.log(popup)
    },


    async sendAndFinish({ state, commit, dispatch }, successPopup) {
      if (state.DEMO) {
        const application_number = '12345'
        if (application_number)
          localStorage.setItem('application_number', application_number)
        commit('setShow', false)
        if (successPopup) {
          dispatch('showErrorPopup', successPopup)
        } else
          commit('setThanksShow', true)
        return
      }
      let formData = new FormData(window.document.getElementById('pform-form'))
      commit('addLoad', 'sendAndFinish')
      for (let key in state.form.additions) {
        formData.append('additions_' + key, state.form.additions[key])
      }
      await fetch(state.sendUrl,
        {
          body: formData,
          method: "POST",
          mode: 'same-origin',
        }).then(res => {
          if (!res.ok) throw (res.status)
          return res.json()
        }).then(json => {
          if (!json || json.status != 'ok')
            throw (json)
          const application_number = json.application_number
          if (application_number)
            localStorage.setItem('application_number', application_number)
          commit('setShow', false)
          if (successPopup) {
            dispatch('showErrorPopup', successPopup)
          } else
            commit('setThanksShow', true)
        })
        .catch(err => {
          console.error(err)

          if (['err', 'error'].includes(err?.status)) {
            if (err.messages && err.messages.length && Array.isArray(err.messages)) {
              let message = err.messages[0]
              dispatch('showErrorPopup', {
                title: 'Ошибка!',
                text: (typeof (message) === 'string') ? message : 'Что-то пошло не так',
                button: 'Ок'
              })
              if (typeof (message) !== 'string')
                console.error('Неверный message:', message)
            }
          } else
            return dispatch('showErrorPopup', {
              title: 'Ошибка!',
              text: 'Попробуйте повторить запрос',
              button: 'Повторить',
              closable: false,
              action: () => { dispatch('sendAndFinish', successPopup) }
            })
        })
      commit('removeLoad', 'sendAndFinish')
    },
    async getprolongPayment({ state, commit, dispatch }) {
      if (state.DEMO) {
        commit('setProlongPaymentRedirect', 'https://rosbankinsurance.ru/prol_test/payd/')
        return '150 000 ₽'
      }

      let formData = new FormData(window.document.getElementById('pform-form'))
      commit('addLoad', 'getprolongPayment')
      for (let key in state.form.additions) {
        formData.append('additions_' + key, state.form.additions[key])
      }
      const payment = await fetch(state.prolongPaymentUrl,
        {
          body: formData,
          method: "POST",
          mode: 'same-origin',
        }).then(res => {
          if (!res.ok) throw (res.status)
          return res.json()
        }).then(json => {
          if (!json || json.status != 'ok')
            throw (json)

          const { payment, redirect } = json
          if (!payment || !(payment instanceof String))
            throw 'Получено неверное значение payment'
          if (!redirect || !(redirect instanceof String))
            throw 'Получено неверное значение redirect'
          
          commit('setProlongPaymentRedirect', redirect)
          return payment
        })
        .catch(err => {
          console.error(err)
          if (['err', 'error'].includes(err?.status)) {
            if (err.messages && err.messages.length && Array.isArray(err.messages)) {
              let message = err.messages[0]
              dispatch('showErrorPopup', {
                title: 'Ошибка!',
                text: (typeof (message) === 'string') ? message : 'Что-то пошло не так',
                button: 'Ок'
              })
              if (typeof (message) !== 'string')
                console.error('Неверный message:', message)
            }
          } else {
            dispatch('showErrorPopup', {
              title: 'Ошибка!',
              text: 'Попробуйте повторить запрос',
              button: 'Повторить',
              closable: false,
              action: () => { dispatch('getprolongPayment') }
            })
          }
          return ''
        })
      commit('removeLoad', 'getprolongPayment')
      return payment
    },
    async sendCode({ state, commit, dispatch }, force) {
      if (state.codeTimer && !force) return
      dispatch('clearTimer')
      dispatch('launchTimer')
      let tel = state.form.applicant.tel
      commit('addLoad', 'sendCode')
      let res = await fetch(state.SMSrequestUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'same-origin',
        body: JSON.stringify({ tel })
      })
        .then(res => {
          if (!res.ok)
            throw (res.status)
          return res.json()
        })
        .then(json => {
          if (json.err == 'die') {
            dispatch('showErrorPopup', {
              title: 'Ошибка!',
              text: 'Что-то пошло не так, возникла техническая&nbsp;ошибка<br>Для решения вопроса обратитесь к менеджеру <b><a class="newred nowrap" href="tel:88007007333">8 800 700 7 333</a><b>',
              button: 'Ок'
            })
            return false
          }
          if (json.status == 'err') {
            if (json.messages && json.messages.length && Array.isArray(json.messages)) {
              let message = json.messages[0]
              if (typeof (message) === 'string')
                dispatch('showErrorPopup', {
                  title: 'Ошибка!',
                  text: message,
                  button: 'Ок'
                })
              else
                console.error('Неверный message:', message)
            }
            return false
          }
          return true
        })
        .catch(err => {
          console.error(err)
          dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Попробуйте повторить запрос',
            button: 'Повторить',
            action: () => { dispatch('sendCode', true) }
          })
          return false
        })
      commit('removeLoad', 'sendCode')
      return res
    },
    async checkCode({ state, commit }, code) {
      commit('addLoad', 'checkCode')
      let res = await fetch(state.checkCodeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'same-origin',
        body: JSON.stringify({ code })
      })
        .then(res => {
          if (!res.ok)
            throw (res.status)
          return res.json()
        })
        .then(json => {
          if (json.err == 'die') {
            return 'die'
          }
          if (json.correct) {
            commit('setCodeOk', true)
            return true
          }
          return false
        })
        .catch(err => {
          console.error(err)
          return null
        })
      commit('removeLoad', 'checkCode')
      return res
    },
    clearTimer({ state, commit }) {
      clearInterval(state.codeTimer)
      commit('setCodeSeconds', 0)
      commit('setCodeTimer', null)
    },
    launchTimer({ state, commit, dispatch }) {
      commit('setCodeSeconds', 60)
      commit('setCodeTimer', setInterval(() => {
        commit('setCodeSeconds', state.codeSeconds - 1)
        if (state.codeSeconds == 0) {
          dispatch('clearTimer')
        }
      }, 1000))
    }
  },
  getters: {
    loading(state) {
      return state.loads.length ? true : false
    },
    timerstring(state) {
      let min = (Math.floor(state.codeSeconds / 60) + '').padStart(2, '0')
      let sec = ((state.codeSeconds % 60) + '').padStart(2, '0')
      return min + ':' + sec
    },
  }
})
